<template>
  <v-container>
    <v-row justify="center">
      <ViewHeader :title="viewTitle" />
      <v-col cols="12">
        <v-card class="px-6 py-3 pt-12" style="min-height: 650px;">
          <template v-if="!loading">
            <v-row no-gutters>
              <v-col cols="12">
                <v-form
                  v-model="valid"
                  :class="{ 'mt-5': $vuetify.breakpoint.smAndUp }"
                >
                  <v-row justify="center" class="mt-5">
                    <v-col cols="12" sm="10" md="5" xl="4">
                      <h2 class="mb-3">
                        {{ $t("message.common.generalData") }}
                      </h2>
                      <v-text-field
                        v-for="item in [form.name, form.email]"
                        :key="item.id"
                        v-model="item.value"
                        v-validate="{ required: item.required }"
                        :data-vv-name="$t(item.label)"
                        :error-messages="errors.collect($t(item.label))"
                        :label="
                          item.required ? `${$t(item.label)} *` : $t(item.label)
                        "
                        :required="item.required"
                        :disabled="!editable"
                      ></v-text-field>
                      <!-- <v-autocomplete
                        v-model="form.categories.value"
                        :items="items"
                        chips
                        multiple
                        :data-vv-name="$t(form.categories.label)"
                        item-text="name"
                        item-value="id"
                        :error-messages="
                          errors.collect($t(form.categories.label))
                        "
                        return-object
                        autocomplete="off"
                        v-validate="{ required: true }"
                        :label="
                          form.categories.required
                            ? `${$t(form.categories.label)} *`
                            : $t(form.categories.label)
                        "
                        :required="form.categories.required"
                        :disabled="form.categories.disabled || !editable"
                      ></v-autocomplete> -->
                    </v-col>
                    <v-col cols="12" sm="10" md="5" xl="4">
                      <h2 class="mb-3">
                        {{ $t("message.common.billingData") }}
                      </h2>
                      <v-text-field
                        :key="form.gov_tax_number.id"
                        v-model="form.gov_tax_number.value"
                        v-validate="{ required: form.gov_tax_number.required }"
                        :data-vv-name="$t(form.gov_tax_number.label)"
                        :error-messages="
                          errors.collect($t(form.gov_tax_number.label))
                        "
                        :label="
                          form.gov_tax_number.required
                            ? `${$t(form.gov_tax_number.label)} *`
                            : $t(form.gov_tax_number.label)
                        "
                        :required="form.gov_tax_number.required"
                        :disabled="form.gov_tax_number.disabled || !editable"
                        append-icon="icon-search"
                        @click:append="onTaxNumberSearch"
                      ></v-text-field>
                      <v-text-field
                        v-for="item in [
                          form.legal_name,
                          form.city,
                          form.postal_code,
                          form.street
                        ]"
                        :key="item.id"
                        v-model="item.value"
                        v-validate="{ required: item.required }"
                        :data-vv-name="$t(item.label)"
                        :error-messages="errors.collect($t(item.label))"
                        :label="
                          item.required ? `${$t(item.label)} *` : $t(item.label)
                        "
                        :required="item.required"
                        :disabled="item.disabled || !editable"
                      ></v-text-field>
                      <v-select
                        v-model="form.country_code.value"
                        :items="countries"
                        :data-vv-name="$t(form.country_code.label)"
                        :error-messages="
                          errors.collect($t(form.country_code.label))
                        "
                        :label="
                          form.country_code.required
                            ? `${$t(form.country_code.label)} *`
                            : $t(form.country_code.label)
                        "
                        :required="form.country_code.required"
                        :disabled="form.country_code.disabled || !editable"
                        item-text="name"
                        item-value="code"
                      ></v-select>
                    </v-col>
                    <SectionLoader :status="loading" />
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
            <v-row v-if="canManageCompanyData" no-gutters>
              <v-col cols="12" class="buttons">
                <ui-button
                  v-if="!editable"
                  color="primary"
                  @click="handleEditClick"
                  outlined
                  icon="icon-edit"
                  large
                  class="my-4"
                  width="140"
                >
                  {{ $t("message.common.edit") }}
                </ui-button>
                <ui-button
                  v-if="editable"
                  color="primary"
                  @click="handleCancelClick"
                  outlined
                  large
                  class="my-4"
                  width="140"
                >
                  {{ $t("message.common.cancel") }}
                </ui-button>
                <ui-button
                  v-if="editable"
                  color="primary"
                  @click="handleSaveClick"
                  :icon="!editable ? 'icon-edit' : undefined"
                  large
                  class="my-4"
                  width="140"
                >
                  {{ $t("message.common.save") }}
                </ui-button>
              </v-col>
            </v-row>
          </template>
          <template v-if="loading">
            <SectionLoader :status="loading" />
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SectionLoader from "@/components/Loader/SectionLoader.vue";
import ViewHeader from "@/components/ui/ViewHeader.vue";

import { permissionsInfo } from "@/helpers/mixins/permissions-info";
import { companyProfileMixin } from "@/helpers/mixins/company-profile";

export default {
  name: "ProfileCompanyProfile",
  components: {
    SectionLoader,
    ViewHeader
  },
  mixins: [permissionsInfo, companyProfileMixin],
  data() {
    return {
      phone: null,
      viewTitle: this.$t("message.common.yourCompany"),
      editable: false,
      valid: true
    };
  },

  async created() {
    this.$store.commit("company/SET_LOADING", true);
    await this.fetchCountries();
    this.setForm();
    this.$store.commit("company/SET_LOADING", false);
  },

  mounted() {
    this.form.email.value = this.$store.state.auth.user.email;
  }
};
</script>

<style lang="scss" scoped>
.buttons {
  display: flex;
  justify-content: center;
  gap: $spacing;
}
</style>
